export default __webpack_public_path__ + "static/media/SEC1450.34I-32570_-19764_0.974c42a1.jpg";